module.exports = __webpack_public_path__ + "img/telecommunications.13e1f489.svg";